import { API } from 'aws-amplify';
import { MemberOrderResponse, UpdateMembershipInfoRequest } from '../data_types/member-order';
import { auth, getAuthHeaders } from './auth';

const sendPayload = async (
    submitAction: string,
    membershipInfo: MemberOrderResponse,
    request: UpdateMembershipInfoRequest,
): Promise<void> => {
    const session = await auth.getSession();
    if (!session.authenticated) {
        throw new Error('Not authenticated');
    }
    return API.post('membership', '/membership-info', {
        headers: getAuthHeaders(),
        body: {
            ...request,
        },
    });
};

export default sendPayload;
